import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "ic-quarto_c7aeda69b8e8bd0769dab9d7137cf327",
  "use": "ic-quarto_c7aeda69b8e8bd0769dab9d7137cf327-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"ic-quarto_c7aeda69b8e8bd0769dab9d7137cf327\">\n    <path fill-rule=\"nonzero\" d=\"M10.599 16a3 3 0 1 0 .002-6 3 3 0 0 0-.002 6zm13.197-4.8H15.4a.6.6 0 0 0-.6.6v5.4H6.4V9.4a.6.6 0 0 0-.6-.6H4.6a.6.6 0 0 0-.6.6v13.197a.6.6 0 0 0 .6.6h1.2a.6.6 0 0 0 .6-.6V20.8h19.2v1.8a.6.6 0 0 0 .6.6h1.2a.6.6 0 0 0 .6-.6V15.4a4.2 4.2 0 0 0-4.2-4.199h-.004z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id